import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import { dateUtils } from '@/utils'
import { CalendarConfig } from '../types'

const defaultCalendarConfig: CalendarConfig = {
  minDate: dateUtils.convertToYYYYMMDD(new Date()),
  maxDate: dateUtils.convertToYYYYMMDD(new Date()),
  disabledDays: {},
}

const calendarConfigContext = createContext<CalendarConfig>(defaultCalendarConfig)

const calendarConfigSetter = createContext<Dispatch<SetStateAction<CalendarConfig>>>(
  () => undefined,
)

export function CalendarConfigProvider(props: PropsWithChildren) {
  const [localCalendarConfig, setLocalCalendarConfig] = useState<CalendarConfig>(
    () => defaultCalendarConfig,
  )

  return (
    <calendarConfigContext.Provider value={localCalendarConfig}>
      <calendarConfigSetter.Provider value={setLocalCalendarConfig}>
        {props.children}
      </calendarConfigSetter.Provider>
    </calendarConfigContext.Provider>
  )
}

export function useCalendarConfig() {
  return useContext(calendarConfigContext)
}

export function useSetCalendarConfig() {
  return useContext(calendarConfigSetter)
}
